var o,e=5,l=10,p="/api/log",r=null!==(o=process.env.NEXT_PUBLIC_PORTAL)&&void 0!==o?o:"PORTAL";export{e as LOGGER_ARR_SIZE,l as LOGGER_PUSH_TIME,r as SERVICE_NAME,p as URL};
//# sourceMappingURL=constants.js.map
